import { yupResolver } from '@hookform/resolvers/yup';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Button, Grid, Typography } from '@mui/material';
import bgQuestionCheckbox from 'assets/images/backgrounds/question-type/bg-checkbox.jpg';
import bgQuestionDate from 'assets/images/backgrounds/question-type/bg-date.jpg';
import bgQuestionDropdown from 'assets/images/backgrounds/question-type/bg-dropdown.jpg';
import bgQuestionEmoji from 'assets/images/backgrounds/question-type/bg-emoji.jpg';
import bgQuestionMatrixCheckbox from 'assets/images/backgrounds/question-type/bg-matrix-checkbox.jpg';
import bgQuestionMatrixRadio from 'assets/images/backgrounds/question-type/bg-matrix-radio.jpg';
import bgQuestionMatrixTextbox from 'assets/images/backgrounds/question-type/bg-matrix-textbox.jpg';
import bgQuestionNumber from 'assets/images/backgrounds/question-type/bg-number.jpg';
// import bgQuestionTextbox from 'assets/images/backgrounds/question-type/bg-question-textbox.jpg';
import bgQuestionRank from 'assets/images/backgrounds/question-type/bg-rank.jpg';
import bgQuestionScore from 'assets/images/backgrounds/question-type/bg-score.jpg';
// import bgQuestionSingleChoice from 'assets/images/backgrounds/question-type/bg-single-choice.jpg';
import bgQuestionSliderScale from 'assets/images/backgrounds/question-type/bg-slider-scale.jpg';
import bgQuestionStarFull from 'assets/images/backgrounds/question-type/bg-star-full.jpg';
import bgQuestionStarHalf from 'assets/images/backgrounds/question-type/bg-star-half.jpg';
import bgQuestionTextboxRecommendMultiChoice from 'assets/images/backgrounds/question-type/bg-text-recommend-multi-choice.jpg';
import bgQuestionTextboxRecommend from 'assets/images/backgrounds/question-type/bg-text-recommend.jpg';
import BaseTextField from 'common/components/base-text-field';
import FormProvider from 'common/components/form-provider';
import { QuestionType } from 'pages/admin/campaign-overview/constants';
import React, { useCallback, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { handleError } from 'utils/helpers';
import * as yup from 'yup';
import QuestionCheckbox from '../question/question-checkbox';
import QuestionDate from '../question/question-date';
import QuestionDropdown from '../question/question-dropdown';
import QuestionEmoji from '../question/question-emoji';
import QuestionImage from '../question/question-image';
import QuestionImageWithTitle from '../question/question-image-with-title';
import QuestionMatrixCheckbox from '../question/question-matrix-checkbox';
import QuestionMatrixRadio from '../question/question-matrix-radio';
import QuestionMatrixTextbox from '../question/question-matrix-textbox';
import QuestionNumber from '../question/question-number';
import QuestionRank from '../question/question-rank';
import QuestionScore from '../question/question-score';
import QuestionScoreStar from '../question/question-score-star';
import QuestionSingleShoice from '../question/question-single-choice';
import QuestionSliderScale from '../question/question-slider-scale';
import AnswerQuestionTextbox from '../question/question-textbox';
import QuestionTextboxRecommend from '../question/question-textbox-recommend';
import QuestionTextboxRecommendMultiChoice from '../question/question-textbox-recommend-multi-choice';
import { colors } from 'common/constants';
import { useAppSelector, useAppDispatch } from 'common/hook';
import {
    selectSurveyImage,
    selectWelcomeTextColor,
} from 'common/theme-selectors';
import BrandLogo from 'common/components/brand-logo';
import {
    captureTimeStamp as captureTimeStampAction,
    // setListQuestion,
} from 'slices/previewSurveySlice';
// import { setIsLoading } from 'slices/loadingSlice';
import { IQuestionPreview } from 'types/previewCampaign';
import { saveSurveyAnswersToThirdParty } from 'services/campaign.service';
import { setIsLoading } from 'slices/loadingSlice';
import { useParams } from 'react-router-dom';

const fileMaxSize = 20;
const fileMaxSizeInByte = fileMaxSize * 1024 * 1024;
const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];

const textRequire = 'Vui lòng trả lời câu hỏi này';

const imageYupPreparation = (question: IQuestionPreview) => {
    let baseAnswerYup = yup
        .mixed()
        .test(
            'fileType',
            'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: .png, .jpg, .jpeg ',
            (value) => {
                if (!value) return true;
                const isValidType =
                    value instanceof File &&
                    SUPPORTED_FORMATS.includes(value.type);

                return isValidType;
            }
        )
        .test(
            'fileSize',
            `File không được vượt quá ${fileMaxSize}MB`,
            (value) => {
                if (!value) return true;
                return value instanceof File && value.size <= fileMaxSizeInByte;
            }
        );
    if (question.required) {
        baseAnswerYup = baseAnswerYup.test(
            'is-required',
            textRequire,
            (value) => {
                return value instanceof File;
            }
        );
    }
    return yup.object({
        answers: baseAnswerYup,
        questionId: yup.number(),
    });
};

const imageWithTitleYupPreparation = (question: IQuestionPreview) => {
    const baseAnswersYup = yup
        .array()
        .of(
            yup.object({
                image: yup
                    .mixed()
                    .nullable()
                    .test(
                        'fileType',
                        'Ảnh không đúng định dạng, vui lòng tải ảnh có định dạng sau: .png, .jpg, .jpeg ',
                        (file) => {
                            if (!file) return true;
                            return (
                                file instanceof File &&
                                SUPPORTED_FORMATS.includes(file.type)
                            );
                        }
                    )
                    .test(
                        'fileSize',
                        `File không được vượt quá ${fileMaxSize}MB`,
                        (file) => {
                            if (!(file instanceof File)) return true;
                            return file.size <= fileMaxSizeInByte;
                        }
                    ),
            })
        )
        .test('has-image-if-required', textRequire, (value) => {
            if (!question.required) return true;
            return (
                Array.isArray(value) &&
                value.some((item) => item?.image instanceof File)
            );
        });

    return yup.object({
        answers: baseAnswersYup,
        questionId: yup.number(),
    });
};

const matrixCheckBoxYupPreparation = (question: IQuestionPreview) => {
    let baseAnswersYup = yup.array().of(yup.array().of(yup.boolean()));
    if (question.required) {
        baseAnswersYup = baseAnswersYup.test(
            'is-required',
            textRequire,
            (value) => {
                // check if value is an array and each item is an array has aleast 1 boolean true
                return (
                    Array.isArray(value) &&
                    value?.every((item) =>
                        item?.some((subItem) => subItem === true)
                    )
                );
            }
        );
    }
    return yup.object({
        answers: baseAnswersYup,
        questionId: yup.number(),
    });
};

const checkBoxQuestionYupPreparation = (question: IQuestionPreview) => {
    const { minChoice, maxChoice } = question.logics || {};
    let baseAnswersYup = yup
        .array()
        .of(yup.number())
        .test(
            'noAnswerOrOtherAnswers',
            'Không được chọn cùng lúc "Không có đáp án nào" và các đáp án trên đó',
            (value) => {
                const listOptionTypeInValue: number[] = [];
                if (!value) return true;
                if (value.length === 0) return true;
                value.forEach((item) => {
                    const option = question.answers.find(
                        (answer: any) => answer.id === item // eslint-disable-line @typescript-eslint/no-explicit-any
                    );
                    if (option) {
                        listOptionTypeInValue.push(option.type);
                    } else {
                        listOptionTypeInValue.push(0);
                    }
                });
                // if listOptionTypeInValue include 2 then it can not include 1 or 0
                if (listOptionTypeInValue.includes(2)) {
                    if (
                        listOptionTypeInValue.includes(1) ||
                        listOptionTypeInValue.includes(0)
                    ) {
                        return false;
                    }
                }
                return true;
            }
        );
    if (question.required) {
        baseAnswersYup = baseAnswersYup.test(
            'is-required',
            textRequire,
            (value) => {
                return value && value?.length > 0;
            }
        );
    }
    if (minChoice) {
        baseAnswersYup = baseAnswersYup.test(
            'min-choice',
            `Chọn tối thiểu ${minChoice} đáp án`,
            (value) => {
                if (!value) return true;
                if (value.length === 0) return true;

                return value && value?.length >= (minChoice || 0);
            }
        );
    }
    if (maxChoice) {
        baseAnswersYup = baseAnswersYup.test(
            'max-choice',
            `Chọn tối đa ${maxChoice} đáp án`,
            (value) => {
                if (!value) return true;
                if (value.length === 0) return true;

                return value && value?.length <= (maxChoice || 1);
            }
        );
    }
    return yup.object({
        answers: baseAnswersYup,
        questionId: yup.number(),
        answersOtherText: yup.string().when('answers', {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            is: (val: any) => {
                const otherOption = question.answers.find(
                    (item: any) => item.type === 1 // eslint-disable-line @typescript-eslint/no-explicit-any
                );
                if (!otherOption) return false;
                return val.includes(otherOption.id);
            },
            then: (schema) => schema.required('Vui lòng nhập'),
        }),
    });
};

interface IAnswerTheSurveyProps {
    setSurveyStep?: (step: number) => void;
}
const AnswerTargetedSurvey: React.FC<IAnswerTheSurveyProps> = ({
    setSurveyStep,
}) => {
    const dispatch = useAppDispatch();
    const isSubmittingRef = useRef(false);
    const onSubmitCallbackRef = useRef<(() => void) | null>(null);
    const [currentQuestion, setCurrentQuestion] =
        React.useState<IQuestionPreview>();
    const [currentQuestionIndex, setCurrentQuestionIndex] = React.useState(0);
    const questions = useAppSelector((state) => state.previewSurvey.questions);
    const geoCoords = useAppSelector((state) => state.geoLocation.coords);
    const surveyImage = useAppSelector(selectSurveyImage);
    const welcomeTextColor = useAppSelector(selectWelcomeTextColor);
    const campaignId = useParams<{ id: string }>().id;
    const surveyState = useAppSelector(
        (state) => state.previewSurvey.surveyState
    );

    const backgroundWithQuestionType = {
        [QuestionType.Textbox]: bgQuestionSliderScale,
        [QuestionType.SingleChoice]: bgQuestionSliderScale,
        [QuestionType.Checkbox]: bgQuestionCheckbox,
        [QuestionType.Score]: bgQuestionScore,
        [QuestionType.ScoreStarFull]: bgQuestionStarFull,
        [QuestionType.ScoreStarHalf]: bgQuestionStarHalf,
        [QuestionType.SliderScale]: bgQuestionSliderScale,
        [QuestionType.Rank]: bgQuestionRank,
        [QuestionType.MatrixCheckbox]: bgQuestionMatrixCheckbox,
        [QuestionType.MatrixRadio]: bgQuestionMatrixRadio,
        [QuestionType.MatrixText]: bgQuestionMatrixTextbox,
        [QuestionType.Dropdown]: bgQuestionDropdown,
        [QuestionType.Number]: bgQuestionNumber,
        [QuestionType.TextboxRecommend]: bgQuestionTextboxRecommend,
        [QuestionType.TextboxRecommendMultiChoice]:
            bgQuestionTextboxRecommendMultiChoice,
        [QuestionType.Date]: bgQuestionDate,
        [QuestionType.Image]: bgQuestionScore,
        [QuestionType.ImageWithTitle]: bgQuestionStarFull,
        [QuestionType.Emoji]: bgQuestionEmoji,
    };

    useEffect(() => {
        setCurrentQuestion(questions[0]);
    }, [questions]);

    const createValidationSchemaAndDefaults = (
        questions: IQuestionPreview[]
    ) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const shape: Record<string, yup.Schema<any>> = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const defaultValues: Record<string, any> = {}; // Để lưu trữ defaultValues

        questions.forEach((question: IQuestionPreview) => {
            const questionKey = `question_${question.id}`;
            switch (question.type) {
                case QuestionType.Textbox:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup
                                  .string()
                                  .required(textRequire)
                                  .test(
                                      'is-empty-string',
                                      textRequire,
                                      (value) => {
                                          return value?.trim() !== '';
                                      }
                                  )
                            : yup.string().nullable(),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        answers: '',
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.Checkbox:
                    shape[questionKey] =
                        checkBoxQuestionYupPreparation(question);

                    defaultValues[questionKey] = {
                        answers: [],
                        questionId: question?.id,
                        answersOtherText: '',
                    };
                    break;
                case QuestionType.SingleChoice:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup.string().required(textRequire)
                            : yup.string().nullable(),
                        questionId: yup.number(),
                        answersOtherText: yup.string().when('answers', {
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            is: (val: any) => {
                                const otherOption = question.answers.find(
                                    (item: any) => item.type === 1 // eslint-disable-line @typescript-eslint/no-explicit-any
                                );
                                if (!otherOption) return false;
                                return Number(val) === otherOption.id;
                            },
                            then: (schema) => schema.required('Vui lòng nhập'),
                        }),
                    });
                    defaultValues[questionKey] = {
                        answers: null,
                        questionId: question?.id,
                        answersOtherText: '',
                    };
                    break;
                case QuestionType.Score:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup.number().required(textRequire)
                            : yup.number().nullable(),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        answers: null,
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.ScoreStarHalf:
                case QuestionType.ScoreStarFull:
                    shape[questionKey] = yup.object({
                        answers: yup.array().of(
                            yup.object({
                                star: question.required
                                    ? yup.number().required(textRequire)
                                    : yup.number().nullable(),
                                id: yup.number(),
                            })
                        ),
                        questionId: yup.number(),
                    });

                    defaultValues[questionKey] = {
                        questionId: question.id,
                    };
                    break;
                case QuestionType.SliderScale:
                    shape[questionKey] = yup.object({
                        answers: yup.array().of(
                            yup.object({
                                score: question.required
                                    ? yup.number().required(textRequire)
                                    : yup.number().nullable(),
                                id: yup.number(),
                            })
                        ),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        answers: question.answers.map(
                            (answer: { id: number; label: string }) => ({
                                score: 0,
                                id: answer.id,
                            })
                        ),
                        questionId: question.id,
                    };
                    break;
                case QuestionType.Rank:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup.array().of(
                                  yup.object({
                                      id: yup.number(),
                                      label: yup.string(),
                                      position: yup
                                          .number()
                                          .required(textRequire),
                                  })
                              )
                            : yup.array(),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        answers: [...question.answers],
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.MatrixCheckbox:
                    shape[questionKey] = matrixCheckBoxYupPreparation(question);
                    defaultValues[questionKey] = {
                        answers: [...question.answers.matrix],
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.MatrixRadio:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup
                                  .array()
                                  .of(yup.string())
                                  .test('is-required', textRequire, (value) => {
                                      // check if value is an array that contain 5 string
                                      return (
                                          Array.isArray(value) &&
                                          value?.every(
                                              (item) =>
                                                  typeof item === 'string' &&
                                                  (item as string).length > 0
                                          )
                                      );
                                  })
                            : yup.array(),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        answers: [...question.answers.matrix],
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.MatrixText:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup
                                  .array()
                                  .of(yup.array().of(yup.string()))
                                  .test('is-required', textRequire, (value) => {
                                      // check if value is an array and each item is an array that contain all string not empty
                                      return (
                                          Array.isArray(value) &&
                                          value?.every((item) =>
                                              item?.every(
                                                  (subItem) =>
                                                      typeof subItem ===
                                                          'string' &&
                                                      subItem.length > 0
                                              )
                                          )
                                      );
                                  })
                            : yup.array(),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        answers: [...question.answers.matrix],
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.Dropdown:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup.object().required(textRequire)
                            : yup.object().nullable(),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        answers: null,
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.Number:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup
                                  .number()
                                  .typeError('Vui lòng nhập số')
                                  .required(textRequire)
                            : yup
                                  .number()
                                  .typeError('Vui lòng nhập số')
                                  .nullable(),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        answers: null,
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.TextboxRecommend:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup
                                  .object({
                                      label: yup.string(),
                                      value: yup.number(),
                                  })
                                  .required(textRequire)
                            : yup
                                  .object({
                                      label: yup.string(),
                                      value: yup.number(),
                                  })
                                  .nullable(),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        answers: null,
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.TextboxRecommendMultiChoice:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup
                                  .array()
                                  .test('is-required', textRequire, (value) => {
                                      return (
                                          Array.isArray(value) &&
                                          value.length > 0
                                      );
                                  })
                            : yup.array(),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        answers: [],
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.Date:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup
                                  .object({
                                      day: yup.string().nullable(),
                                      month: yup.string().nullable(),
                                      year: yup.string().nullable(),
                                  })
                                  .test('is-required', textRequire, (value) => {
                                      return !!(
                                          value &&
                                          value.day &&
                                          value.month &&
                                          value.year
                                      );
                                  })
                            : yup.object({
                                  day: yup.string().nullable(),
                                  month: yup.string().nullable(),
                                  year: yup.string().nullable(),
                              }),
                        questionId: yup.number(),
                    });

                    defaultValues[questionKey] = {
                        answers: {
                            day: '',
                            month: '',
                            year: '',
                        },
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.Image:
                    shape[questionKey] = imageYupPreparation(question);
                    defaultValues[questionKey] = {
                        answers: '',
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.ImageWithTitle:
                    shape[questionKey] = imageWithTitleYupPreparation(question);
                    defaultValues[questionKey] = {
                        answers: [],
                        questionId: question?.id,
                    };
                    break;
                case QuestionType.Emoji:
                    shape[questionKey] = yup.object({
                        answers: question.required
                            ? yup
                                  .array()
                                  .of(
                                      yup.object({
                                          emoji: yup.string().nullable(),
                                          id: yup.number(),
                                      })
                                  )
                                  .test('is-required', textRequire, (value) => {
                                      return (
                                          Array.isArray(value) &&
                                          value.every((item) => {
                                              return item.emoji !== '';
                                          })
                                      );
                                  })
                            : yup.array().of(
                                  yup.object({
                                      emoji: yup.string().nullable(),
                                      id: yup.number(),
                                  })
                              ),
                        questionId: yup.number(),
                    });
                    defaultValues[questionKey] = {
                        questionId: question.id,
                    };
                    break;
                default:
                    break;
            }
        });
        const validationSchema = yup.object().shape(shape);
        return { validationSchema, defaultValues };
    };

    const { validationSchema, defaultValues } = React.useMemo(() => {
        return createValidationSchemaAndDefaults(questions || []);
    }, [questions]);
    const methods = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {},
        mode: 'onChange',
    });

    useEffect(() => {
        const prevDefaultValues = JSON.stringify(methods.getValues());
        const newDefaultValues = JSON.stringify(defaultValues);

        if (prevDefaultValues !== newDefaultValues) {
            methods.reset(defaultValues);
        }
    }, [defaultValues, methods]);

    const {
        handleSubmit,
        watch,
        // setError,
        formState: { errors },
    } = methods;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function convertFormToRow(formResult: any, questions: IQuestionPreview[]) {
        const row: Record<string, string> = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(formResult).forEach((ans: any) => {
            const q = questions.find((q) => q.id === ans.questionId);
            if (q) {
                let answerValue = '';

                if (Array.isArray(ans.answers)) {
                    if (ans.answers.length > 0) {
                        const firstAnswer = ans.answers[0];
                        if (
                            firstAnswer.star !== undefined &&
                            firstAnswer.star !== null
                        ) {
                            answerValue = String(firstAnswer.star);
                        } else if (
                            firstAnswer.emoji !== undefined &&
                            firstAnswer.emoji !== null
                        ) {
                            answerValue = String(firstAnswer.emoji);
                        } else if (
                            firstAnswer.score !== undefined &&
                            firstAnswer.score !== null
                        ) {
                            answerValue = String(firstAnswer.score);
                        } else if (firstAnswer.id !== undefined) {
                            answerValue = ans.answers
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map((item: any) => item.id || item)
                                .join(', ');
                        } else {
                            answerValue = ans.answers.join(', ');
                        }
                    }
                } else if (
                    typeof ans.answers === 'object' &&
                    ans.answers !== null
                ) {
                    if (
                        ans.answers.day &&
                        ans.answers.month &&
                        ans.answers.year
                    ) {
                        answerValue = `${ans.answers.day}/${ans.answers.month}/${ans.answers.year}`;
                    } else if (ans.answers.label !== undefined) {
                        answerValue = ans.answers.label;
                    } else {
                        answerValue = JSON.stringify(ans.answers);
                    }
                } else {
                    answerValue = String(ans.answers || '');
                }

                row[q.question] = answerValue;
            }
        });

        return { rows: [row] };
    }
    const onSubmit = handleSubmit(async (data) => {
        if (isSubmittingRef.current) {
            return;
        }
        isSubmittingRef.current = true;
        const result = convertFormToRow(data, questions);
        try {
            dispatch(setIsLoading(true));
            const res = await saveSurveyAnswersToThirdParty(
                campaignId as string,
                result,
                geoCoords
            );
            const { success, message } = res;
            if (success) {
                toast.success(message);
                setSurveyStep && setSurveyStep(0);
                methods.reset();
                setCurrentQuestionIndex(0);
                setCurrentQuestion(questions[0]);
                isSubmittingRef.current = false;
            } else {
                toast.error(message);
                isSubmittingRef.current = false;
            }
        } catch (error) {
            handleError(error);
            isSubmittingRef.current = false;
        } finally {
            dispatch(setIsLoading(false));
        }
    });
    const answer = watch(`question_${currentQuestion?.id}.answers`);

    const onSubmitCallback = useCallback(() => {
        if (!isSubmittingRef.current) {
            onSubmit();
        }
    }, [onSubmit]);

    useEffect(() => {
        onSubmitCallbackRef.current = onSubmitCallback;
    }, [onSubmitCallback]);

    useEffect(() => {
        // Kiểm tra có thực sự trả lời câu hỏi chưa
        const hasAnswered = () => {
            if (!answer || !currentQuestion) return false;
            switch (currentQuestion.type) {
                case QuestionType.SingleChoice:
                    return answer !== null && answer !== '';

                case QuestionType.Emoji:
                    return (
                        Array.isArray(answer) &&
                        answer.length > 0 &&
                        answer.every(
                            (item) => item?.emoji && item?.emoji.trim() !== ''
                        )
                    );

                case QuestionType.ScoreStarHalf:
                case QuestionType.ScoreStarFull:
                    return (
                        Array.isArray(answer) &&
                        answer.length > 0 &&
                        answer.every(
                            (item) =>
                                item.star !== null &&
                                typeof item.star === 'number'
                        )
                    );

                case QuestionType.Score:
                    return answer !== null;

                default:
                    return !!answer;
            }
        };

        if (hasAnswered()) {
            const nextIndex = currentQuestionIndex + 1;
            if (nextIndex < totalQuestions) {
                const timer = setTimeout(() => {
                    setCurrentQuestionIndex(nextIndex);
                    setCurrentQuestion(questions[nextIndex]);
                    dispatch(captureTimeStampAction());
                }, 100);
                return () => clearTimeout(timer);
            } else {
                onSubmitCallbackRef.current?.();
            }
        }
    }, [answer, currentQuestion, currentQuestionIndex, questions]);

    const totalQuestions = questions?.length || 0;

    const renderQuestion = useCallback(() => {
        const questionKey = `question_${currentQuestion?.id}`;
        switch (currentQuestion?.type) {
            case QuestionType.Textbox:
                return (
                    <AnswerQuestionTextbox
                        key={questionKey}
                        name={`${questionKey}.answers`}
                    />
                );
            case QuestionType.Checkbox:
                return (
                    <QuestionCheckbox
                        key={questionKey}
                        name={`${questionKey}.answers`}
                        options={
                            Array.isArray(currentQuestion?.answers)
                                ? currentQuestion?.answers?.map((item) => ({
                                      label: item.label,
                                      value: item.id,
                                      image: item.image,
                                      type: item.type,
                                  }))
                                : []
                        }
                    />
                );
            case QuestionType.SingleChoice:
                return (
                    <Box>
                        <QuestionSingleShoice
                            key={questionKey}
                            name={`${questionKey}.answers`}
                            options={
                                Array.isArray(currentQuestion?.answers)
                                    ? currentQuestion?.answers?.map((item) => ({
                                          label: item.label,
                                          value: item.label,
                                          image: item.image,
                                          type: item.type,
                                      }))
                                    : []
                            }
                        />
                    </Box>
                );
            case QuestionType.Score:
                return (
                    <QuestionScore
                        key={questionKey}
                        name={`${questionKey}.answers`}
                        options={currentQuestion.answers}
                    />
                );
            case QuestionType.ScoreStarHalf:
                return (
                    <QuestionScoreStar
                        key={questionKey}
                        name={`${questionKey}.answers`}
                        defaultStar={currentQuestion?.defaultStar}
                        options={currentQuestion?.answers}
                        precision={0.5}
                    />
                );
            case QuestionType.ScoreStarFull:
                return (
                    <QuestionScoreStar
                        key={questionKey}
                        name={`${questionKey}.answers`}
                        defaultStar={currentQuestion?.defaultStar}
                        options={currentQuestion?.answers}
                        precision={1}
                    />
                );
            case QuestionType.SliderScale:
                return (
                    <QuestionSliderScale
                        key={questionKey}
                        name={`${questionKey}.answers`}
                        configs={{
                            step: currentQuestion?.step ?? 10,
                            scale: currentQuestion?.scale ?? 100,
                        }}
                        options={currentQuestion?.answers}
                    />
                );
            case QuestionType.Rank:
                return (
                    <QuestionRank
                        key={questionKey}
                        name={`${questionKey}.answers`}
                        options={currentQuestion?.answers}
                    />
                );
            case QuestionType.MatrixCheckbox:
                return (
                    <>
                        <QuestionMatrixCheckbox
                            key={questionKey}
                            name={`${questionKey}.answers`}
                            options={currentQuestion?.answers?.matrix}
                            rowsTitle={currentQuestion?.answers?.rowsTitle}
                            columnsTitle={
                                currentQuestion?.answers?.columnsTitle
                            }
                            matrixAnswerType={
                                currentQuestion?.logics?.matrixAnswerType
                            }
                        />
                        <Box
                            sx={{
                                marginTop: '1rem',
                            }}
                        >
                            {errors[questionKey] && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: colors.textError,
                                        fontSize: '14px',
                                        fontWeight: '400',
                                    }}
                                >
                                    {
                                        // eslint-disable-next-line
                                        (errors[questionKey] as any)?.answers
                                            ?.message
                                    }
                                </Typography>
                            )}
                        </Box>
                    </>
                );
            case QuestionType.MatrixRadio:
                return (
                    <>
                        <QuestionMatrixRadio
                            key={questionKey}
                            name={`${questionKey}.answers`}
                            options={currentQuestion?.answers?.matrix}
                            rowsTitle={currentQuestion?.answers?.rowsTitle}
                            columnsTitle={
                                currentQuestion?.answers?.columnsTitle
                            }
                            matrixAnswerType={
                                currentQuestion?.logics?.matrixAnswerType
                            }
                        />
                        <Box
                            sx={{
                                marginTop: '1rem',
                            }}
                        >
                            {errors[questionKey] && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: colors.textError,
                                        fontSize: '14px',
                                        fontWeight: '400',
                                    }}
                                >
                                    {
                                        // eslint-disable-next-line
                                        (errors[questionKey] as any)?.answers
                                            ?.message
                                    }
                                </Typography>
                            )}
                        </Box>
                    </>
                );
            case QuestionType.MatrixText:
                return (
                    <>
                        <QuestionMatrixTextbox
                            key={questionKey}
                            name={`${questionKey}.answers`}
                            options={currentQuestion?.answers?.matrix}
                            rowsTitle={currentQuestion?.answers?.rowsTitle}
                            columnsTitle={
                                currentQuestion?.answers?.columnsTitle
                            }
                        />
                        <Box
                            sx={{
                                marginTop: '1rem',
                            }}
                        >
                            {errors[questionKey] && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: colors.textError,
                                        fontSize: '14px',
                                        fontWeight: '400',
                                    }}
                                >
                                    {
                                        // eslint-disable-next-line
                                        (errors[questionKey] as any)?.answers
                                            ?.message
                                    }
                                </Typography>
                            )}
                        </Box>
                    </>
                );
            case QuestionType.Dropdown:
                return (
                    <QuestionDropdown
                        key={questionKey}
                        name={`${questionKey}.answers`}
                        options={
                            Array.isArray(currentQuestion?.answers)
                                ? currentQuestion?.answers?.map((item) => ({
                                      label: item.label,
                                      value: item.id,
                                  }))
                                : []
                        }
                    />
                );
            case QuestionType.Number:
                return (
                    <QuestionNumber
                        key={questionKey}
                        name={`${questionKey}.answers`}
                    />
                );
            case QuestionType.TextboxRecommend:
                return (
                    <QuestionTextboxRecommend
                        key={questionKey}
                        name={`${questionKey}.answers`}
                        options={
                            Array.isArray(currentQuestion?.answers)
                                ? currentQuestion?.answers?.map((item) => ({
                                      label: item.label,
                                      value: item.id,
                                  }))
                                : []
                        }
                    />
                );
            case QuestionType.TextboxRecommendMultiChoice:
                return (
                    <QuestionTextboxRecommendMultiChoice
                        key={questionKey}
                        name={`${questionKey}.answers`}
                        options={
                            Array.isArray(currentQuestion?.answers)
                                ? currentQuestion?.answers?.map((item) => ({
                                      label: item.label,
                                      value: item.id,
                                  }))
                                : []
                        }
                    />
                );
            case QuestionType.Date:
                return (
                    <>
                        <QuestionDate
                            key={questionKey}
                            name={`${questionKey}.answers`}
                        />
                        <Box
                            sx={{
                                marginTop: '1rem',
                            }}
                        >
                            {errors[questionKey] && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: colors.textError,
                                        fontSize: '14px',
                                        fontWeight: '400',
                                    }}
                                >
                                    {
                                        // eslint-disable-next-line
                                        (errors[questionKey] as any)?.answers
                                            ?.message
                                    }
                                </Typography>
                            )}
                        </Box>
                    </>
                );
            case QuestionType.Image:
                return (
                    <QuestionImage
                        key={questionKey}
                        name={`${questionKey}.answers`}
                        maxFileSize={fileMaxSize}
                    />
                );
            case QuestionType.ImageWithTitle:
                return (
                    <>
                        <QuestionImageWithTitle
                            key={questionKey}
                            name={`${questionKey}.answers`}
                            options={currentQuestion?.answers?.images}
                            maxFileSize={fileMaxSize}
                        />
                        <Box
                            sx={{
                                marginTop: '1rem',
                            }}
                        >
                            {errors[questionKey] && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: colors.textError,
                                        fontSize: '14px',
                                        fontWeight: '400',
                                    }}
                                >
                                    {
                                        // eslint-disable-next-line
                                        (errors[questionKey] as any)?.answers
                                            ?.message
                                    }
                                </Typography>
                            )}
                        </Box>
                    </>
                );
            case QuestionType.Emoji:
                return (
                    <>
                        <QuestionEmoji
                            key={questionKey}
                            name={`${questionKey}.answers`}
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: ['space-between', 'flex-start'],
                                gap: [0, 5],
                            }}
                            options={currentQuestion?.answers}
                            numberOfEmojis={
                                currentQuestion?.numberOfEmojis ?? 0
                            }
                        />
                        <Box
                            sx={{
                                marginTop: '1rem',
                            }}
                        >
                            {errors[questionKey] && (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: colors.textError,
                                        fontSize: '14px',
                                        fontWeight: '400',
                                    }}
                                >
                                    {
                                        // eslint-disable-next-line
                                        (errors[questionKey] as any)?.answers
                                            ?.message
                                    }
                                </Typography>
                            )}
                        </Box>
                    </>
                );
        }
    }, [currentQuestion, errors]);

    return (
        <Box component="div" tabIndex={0}>
            <Grid container sx={{ position: 'relative' }}>
                <Grid
                    item
                    xs={12}
                    md={8}
                    sx={{
                        padding: ['2rem', '2rem', '2rem', '4rem', '4rem'],
                        backgroundImage: [
                            `url(${surveyImage ?? backgroundWithQuestionType[currentQuestion?.type as keyof typeof backgroundWithQuestionType]})`,
                            'unset',
                        ],
                        backgroundColor: ['unset', '#EFF1FF'],
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        height: '100vh',
                        overflow: 'auto',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={onSubmit}>
                        <Grid
                            container
                            sx={{
                                marginBottom: [
                                    '1rem',
                                    '1rem',
                                    '1rem',
                                    '3rem',
                                    '3rem',
                                ],
                                display: ['none', 'flex'],
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <Grid item md={12}>
                                <BrandLogo width={130} alt="Logo SurveyTrue" />
                            </Grid>
                            <Grid
                                item
                                md={12}
                                sm={12}
                                xs={12}
                                sx={{
                                    display: 'flex',
                                    gap: 2,
                                    justifyContent: 'flex-end',
                                    alignItems: 'center',
                                }}
                            >
                                <Button
                                    onClick={() => {
                                        methods.reset();
                                        setCurrentQuestionIndex(0);
                                        setCurrentQuestion(questions[0]);
                                        setSurveyStep && setSurveyStep(0);
                                    }}
                                    variant="contained"
                                    sx={{
                                        background:
                                            'linear-gradient(90deg, var(--color-primary) 0%, var(--color-primary-mid) 100%)',
                                        fontWeight: 700,
                                        borderRadius: 10,
                                        py: 0.8,
                                        fontSize: '14px',
                                        textTransform: 'none',
                                    }}
                                >
                                    Bắt đầu lại
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container marginBottom={2}>
                            <Grid item md={12}>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        color: [welcomeTextColor, '#8B8B8B'],
                                        fontSize: ['2rem'],
                                        fontWeight: 400,
                                        marginTop: ['2rem'],
                                        marginBottom: ['0.5'],
                                    }}
                                >
                                    {currentQuestionIndex + 1}/{totalQuestions}
                                </Typography>
                            </Grid>
                        </Grid>
                        <BaseTextField
                            name={`question_${currentQuestion?.id}.questionId`}
                            key={`question_${currentQuestion?.id}.questionId`}
                            sx={{
                                display: 'none',
                            }}
                        />
                        <Grid container>
                            <Grid item md={12} xs={12}>
                                <Typography
                                    variant="h4"
                                    fontWeight={'700'}
                                    fontSize={'35px'}
                                    sx={{
                                        color: [
                                            welcomeTextColor,
                                            'primary.main',
                                        ],
                                        fontWeight: 700,
                                        fontSize: [
                                            '1.5rem',
                                            '1.7rem',
                                            '1.6rem',
                                            '2.5rem',
                                            '2.5rem',
                                        ],
                                        marginBottom: [
                                            '2rem',
                                            '2rem',
                                            '2rem',
                                            '2rem',
                                            '2rem',
                                        ],
                                    }}
                                >
                                    {currentQuestion?.question}
                                </Typography>
                                <Box
                                    sx={{
                                        paddingBottom: ['4rem', 'unset'],
                                    }}
                                >
                                    {renderQuestion()}
                                </Box>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </Grid>

                <Grid
                    item
                    xs={12}
                    md={4}
                    sx={{
                        backgroundImage: `url(${surveyImage ?? backgroundWithQuestionType[currentQuestion?.type as keyof typeof backgroundWithQuestionType]})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'bottom',
                        backgroundSize: 'cover',
                        padding: [
                            '2rem 3rem',
                            '2rem 3rem',
                            '2rem 3rem',
                            '3rem 4rem',
                            '3rem 4rem',
                        ],
                        display: ['none', 'none', 'flex'],
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        height: '100vh',
                        overflowY: 'auto',
                        aspectRatio: 619 / 1080,
                    }}
                >
                    <Box
                        sx={{
                            fontWeight: '900',
                            fontSize: [
                                '3rem',
                                '3rem',
                                '2.5rem',
                                '3.5rem',
                                '3.5rem',
                            ],
                            lineHeight: [
                                '2rem',
                                '3rem',
                                '3rem',
                                '4rem',
                                '4rem',
                            ],
                            color: welcomeTextColor,
                        }}
                    >
                        {surveyState.title}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AnswerTargetedSurvey;
